import React from 'react'

class AboutMePage extends React.Component{
  constructor(props){
    super(props)
  }

  render(){
    return(
      <div className="container">
        <div className="row">
          <h3 id="about" className="section-header section center-align"> About Myself </h3>
        </div>
        <div className="col s12">
          <p className="center-align">
          {/*Hi, I'm Liron. I am a full stack developer and a data visualization engineer. I earned my M.S in Computer Science from the <em>City College of New York</em> where I discovered my passion for web applications deveopment and transforming messy datasets to a series of linked charts that people can understand in a glance. I work mostly with Python and JavaScript to create beautiful web applications and dashboards.*/}



          Hi, I'm Liron. I am a developer, tech enthusiast and a data visualization engineer. 
          I earned my M.S in Computer Science from the <em>City College of New York</em> where I discovered my passion for applications development 
          and data visualization. In recent years, I started to deal with distributed and low latency platforms.
          



{/*            Lorem ipsum dolor sit amet, ut wisi. Lobortis nulla sed aenean cras aptent eros, velit vitae orci id nunc lectus, nunc penatibus diam nulla, integer tempus urna a ornare, mi dignissim sit. Netus mattis, semper sodales nunc sed egestas, ligula tincidunt rutrum, euismod morbi dictum sed ipsum a elit. Faucibus lectus sollicitudin lorem at et. Mauris nunc augue, integer ipsum nisl est fringilla quam, eleifend quis vel sed ligula, ultricies wisi tristique amet wisi. Hac facilisis pellentesque, fringilla nonummy, hendrerit mus odio, egestas massa etiam, mollis ultrices aliquam interdum. Nulla nunc ultrices nullam sed orci integer. Diam tempor vitae, orci wisi wisi adipiscing, dolor mi lorem, feugiat ullamco.*/}
          </p>
        </div>
      </div>
    )
  }
}

export default AboutMePage


// WEBPACK FOOTER //
// ./app/components/AboutMePage.js